/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { useEffect, useState } from "react";
import { getPersonasJuridicas, getPersonaJuridica } from "../../../project/services/PersonaJuridicaService";
import PersonaJuridicaDialog from "../persona-juridica/PersonaJuridicaDialog";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialSearchData = {
  numeroCuit: "",
  razonSocial: "",
  rows: 10,
  first: 0,
};
//
// ################################################################################
//
const BuscarPersonaJuridicaDialog = ({ open, onClose, onSelect, canCreateEdit }) => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [personasJuridicas, setPersonasJuridicas] = useState([]);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [openDialogPersonaJuridica, setOpenDialogPersonaJuridica] = useState(false);

  const tableColumns = [
    {
      field: "razon_social",
      headerName: "Razón Social",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.razon_social;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "numero_cuit",
      headerName: "CUIT",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.numero_cuit;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "descripcion_condicion_frente_iva",
      headerName: "Cond.IVA",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_condicion_frente_iva;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="seleccionar">
            <IconButton
              size="small"
              aria-label="select"
              onClick={() => handleClickPersonaJuridica(params.row, "select")}
            >
              <CheckIcon />
            </IconButton>
          </Tooltip>
          {canCreateEdit && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickPersonaJuridica(params.row, "update")}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setRowsPerPage(10);
    setCurrentPage(0);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    load();
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      razonSocial: searchData.razonSocial,
      numeroCuit: searchData.numeroCuit,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getPersonasJuridicas(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setPersonasJuridicas(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleClickPersonaJuridica = (parRow, action) => {
    let _itemCrud = {};

    if (action === "select") {
      onSelect(parRow);
    } else if (action === "update") {
      const loadItem = async () => {
        setIsDoingSomething(true);
        const response = await getPersonaJuridica({ id: parRow.id });
        setIsDoingSomething(false);
        if (response.ok) {
          let _response = response.data.data;
          _itemCrud = {
            id: _response.id,
            condicionFrenteIva: _response.id_condicion_frente_iva,
            numeroCuit: _response.numero_cuit,
            razonSocial: _response.razon_social,
            domicilio: _response.domicilio,
            localidad: _response.localidad,
            departamento: _response.id_departamento ?? "",
            provincia: _response.id_provincia ?? "",
            pais: _response.id_pais ?? "",
            codigoPostal: _response.codigo_postal,
            eMail: _response.email,
            telefonoMovil: _response.telefono_movil,
            telefonoFijo: _response.telefono,
          };
          setActionCrud(action);
          setItemCrud(_itemCrud);
          setOpenDialogPersonaJuridica(true);
        } else {
          setMessage({
            severity: response.messageSeverity,
            messageText: response.messageText,
          });
          setShowMessage(true);
          return;
        }
      };
      loadItem();
    } else {
      setActionCrud(action);
      setItemCrud(_itemCrud);
      setOpenDialogPersonaJuridica(true);
    }
  };
  //
  // ################################################################################
  //
  const handleDialogPersonaJuridicaSave = () => {
    load();
    setOpenDialogPersonaJuridica(false);
  };
  //
  // ################################################################################
  //
  const handleDialogPersonaJuridicaClose = () => {
    setOpenDialogPersonaJuridica(false);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        maxWidth="lg"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Búsqueda de Personas Jurídicas
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box>
            <Grid container spacing={1} sx={{ pb: 1 }}>
              <Grid item xs={12} md={4}>
                <TextField
                  id="numeroCuit"
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  variant="outlined"
                  size="small"
                  name="numeroCuit"
                  label="Número de CUIT"
                  value={searchData.numeroCuit}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  variant="outlined"
                  size="small"
                  name="razonSocial"
                  label="Razón Social"
                  value={searchData.razonSocial}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Box>

          <Box>
            <Grid container sx={{ pb: 1 }}>
              <Grid item xs={12} md={4}>
                {canCreateEdit && (
                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={() => handleClickPersonaJuridica({}, "new")}
                    startIcon={<AddCircleOutlineOutlinedIcon />}
                  >
                    Nuevo
                  </Button>
                )}
              </Grid>

              <Grid item xs={12} md={8}>
                <Button
                  sx={{ mr: 1, float: "right" }}
                  variant="contained"
                  onClick={handleBuscar}
                  startIcon={<SearchIcon />}
                >
                  Buscar
                </Button>
                <Button
                  sx={{ mr: 1, float: "right" }}
                  variant="outlined"
                  onClick={handleLimpiar}
                  startIcon={<CleaningServicesIcon />}
                >
                  Limpiar
                </Button>
              </Grid>
            </Grid>
          </Box>

          <Paper
            sx={{
              width: "100%",
              overflow: "hidden",
              border: "1px solid LightGrey",
            }}
          >
            <DataGrid
              rows={personasJuridicas}
              columns={tableColumns}
              {...tableOptions}
            />
          </Paper>
        </DialogContent>
      </Dialog>

      {/* >>>> Dialog */}

      {openDialogPersonaJuridica && (
        <PersonaJuridicaDialog
          onSave={handleDialogPersonaJuridicaSave}
          onClose={handleDialogPersonaJuridicaClose}
          itemCrud={itemCrud}
          actionCrud={actionCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};

export default BuscarPersonaJuridicaDialog;
